// NOTES
// loan statuses:
//    1. null (no UID, quote not selected,
//    2. active (assigned UID, after quote was selected)
//    3. processing (Admin has to manually move to processing)
//    4. agreed to fund (Admin has to manually move to processing)
//    5. funded (Admin has to manually move to processing))

async function updateLoan(
  user,
  answers,
  setCurrentLoan,
  currentLoan,
  loanQuoteData,
  selectedLoan,
  personalData = {},
  loanStatus,
  loanSectionController,
  DSCRCalculatorQuestions
) {
  // all the query params need to be provided
  // for security reasons to compare those value on backend
  // const targetUrl = `${process.env.CMS_URL}/tours/${tour.id}/?TourID=${tour.id}&UserType=${userType}&UrlAddress=${tour.UrlAddress}`;

  const targetUrl = `${process.env.CMS_URL}/loans/${currentLoan.id}`;

  const savedAnswers = answers.map((answer) => {
    return {
      // username: TODO get cognitouserna or
      // generated localStorage UserID
      // use the info in TalkJS file to get the
      // information into localStorage
      a_string: answer["a_string"],
      q_id: answer["q_id"],
      q_title: answer["q_title"],
    };
  });

  const loanType = answers?.filter((answer) => {
    return answer.q_title === "Loan type";
  })[0]?.a_string;

  const objToRecord = {
    Answers: savedAnswers,
    LoanQuoteData: loanQuoteData,
    SelectedLoan: selectedLoan,
    ...personalData,
    Type: loanType,
  };

  if (loanStatus) {
    objToRecord["Status"] = loanStatus;
  }

  if (loanSectionController) {
    objToRecord["LoanSectionController"] = loanSectionController;
  }

  if (DSCRCalculatorQuestions) {
    objToRecord["DSCRCalculatorQuestions"] = DSCRCalculatorQuestions;
  }

  // extract address
  // because we want to make it searchable on strapi for ease of access
  // future plan, dashboard for managers
  // only do this once , when personal data is supplied
  // on initial create.
  if (Object.keys(personalData).length > 0) {
    const addressString = answers.filter((answer) => {
      return answer.q_title === "Address";
    })?.[0]?.a_string;

    objToRecord["Address"] = addressString;
  }

  let headers = {};
  if (user) {
    // in the beginning, loan is unprotected
    // once UID is assigned to loan, then token is checked

    const token = await user.getIdToken();

    headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  } else {
    headers = {
      "Content-Type": "application/json",
    };
  }

  const res = await fetch(targetUrl, {
    method: "PUT",
    headers: headers,
    body: JSON.stringify(objToRecord),
  });

  const respJSON = await res.json();

  if (setCurrentLoan) {
    setCurrentLoan(respJSON);
  }

  return respJSON;
}

export default updateLoan;
